import { render, staticRenderFns } from "./recycleBin.vue?vue&type=template&id=708a9343&scoped=true&"
import script from "./recycleBin.vue?vue&type=script&lang=js&"
export * from "./recycleBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a9343",
  null
  
)

component.options.__file = "recycleBin.vue"
export default component.exports